import { useEffect, useState } from "react";
import { isBefore, isAfter, addDays, subDays } from "date-fns";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import SurveyEntry_SectionQuestion from "./SurveyEntry_SectionQuestion";

const SurveyEntry_SectionMatrix = ({
  callResultId,
  section,
  questions,
  answers,
  call,
  location,
  onChange,
  isDisabled,
  testMode = false,
}) => {
  const { getMessage } = useLocalization();

  return (
    <Box sx={{ marginTop: "8px" }}>
      {Array.isArray(section.matrixItems) ? (
        <Stack
          spacing={1}
          sx={{ paddingLeft: "4px" }}
        >
          {section.matrixItems.map((item) => (
            <Box>
              <Box
                sx={{
                  paddingLeft: "4px",
                  backgroundColor: "#aaa",
                  color: "#000",
                  borderTopLeftRadius: "4px",
                  borderTopRightRadius: "4px",
                  position: "sticky",
                  top: 47,
                  zIndex: 190,
                }}
              >
                <Typography>{item.name}</Typography>
              </Box>
              <Box>
                <SurveyEntry_SectionQuestion
                  matrixItem={item}
                  callResultId={callResultId}
                  section={section}
                  questions={questions}
                  answers={answers}
                  call={call}
                  location={location}
                  onChange={onChange}
                  isDisabled={isDisabled}
                  testMode={testMode}
                />
              </Box>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography>{getMessage("noMatrixItems")}</Typography>
      )}
    </Box>
  );
};

export default SurveyEntry_SectionMatrix;
